// extracted by mini-css-extract-plugin
export default {"layout":"AppLayout_layout__F3x0E","fog":"AppLayout_fog__PIGBv","mobile":"AppLayout_mobile__-X0d5"};